import { FormGrid } from '@dixa/lib-shared-habla';
import { FieldInputTextInline } from 'lib-knowledge-form';
import { FieldSet } from 'lib-knowledge-management-common/components/fieldSet/index';
import {
  getLabelsForLanguage,
  LanguageModel,
} from 'lib-knowledge-management-common/utils/language';
import { Control, useFieldArray } from 'react-hook-form';

import { CategoryEditModalSchema } from './categoryEditModalSchema';

type MultiLingualCategoryNamesProps = {
  control: Control<CategoryEditModalSchema>;
  enabledLanguages: LanguageModel[];
};

export function MultiLingualCategoryNames({
  control,
  enabledLanguages,
}: MultiLingualCategoryNamesProps): JSX.Element {
  const { fields } = useFieldArray({
    control,
    name: 'titles',
  });

  return (
    <FieldSet legend="Titles">
      <FormGrid>
        {fields.map(({ id, languageId }, index) => (
          <FieldInputTextInline<CategoryEditModalSchema>
            key={id}
            control={control}
            fieldName={`titles.${index}.title`}
            label={
              getLabelsForLanguage({
                languageId,
                languages: enabledLanguages,
              }).description
            }
          />
        ))}
      </FormGrid>
    </FieldSet>
  );
}
